import LocalTaxiRoundedIcon from "@mui/icons-material/LocalTaxiRounded";
import {
  AppBar,
  Box,
  Button,
  Container,
  Drawer,
  List,
  ListItemButton,
  ListItemText,
  Toolbar,
  Typography,
} from "@mui/material";
import { NavLink, Outlet, useNavigate } from "react-router-dom";

import { clearStoredToken } from "../services/auth";

const navItems = [
  { label: "Dashboard", path: "/" },
  { label: "Drivers", path: "/drivers" },
  { label: "Rides", path: "/rides" },
];

export default function AppLayout() {
  const navigate = useNavigate();

  const handleLogout = () => {
    clearStoredToken();
    navigate("/login");
  };

  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      <Drawer
        variant="permanent"
        sx={{
          width: 240,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: 240,
            boxSizing: "border-box",
            bgcolor: "#0e3b43",
            color: "#fff",
          },
        }}
      >
        <Toolbar sx={{ gap: 1.5 }}>
          <LocalTaxiRoundedIcon />
          <Typography variant="h6" fontWeight={700}>
            Movigo
          </Typography>
        </Toolbar>
        <List>
          {navItems.map((item) => (
            <ListItemButton
              key={item.path}
              component={NavLink}
              to={item.path}
              sx={{
                color: "#fff",
                "&.active": {
                  bgcolor: "rgba(255,255,255,0.12)",
                },
              }}
            >
              <ListItemText primary={item.label} />
            </ListItemButton>
          ))}
        </List>
      </Drawer>

      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="static" color="transparent" elevation={0}>
          <Toolbar sx={{ justifyContent: "space-between" }}>
            <Typography variant="h5" fontWeight={700}>
              Operations
            </Typography>
            <Button variant="outlined" onClick={handleLogout}>
              Logout
            </Button>
          </Toolbar>
        </AppBar>

        <Container sx={{ py: 4 }}>
          <Outlet />
        </Container>
      </Box>
    </Box>
  );
}
